import { useEffect, useState } from "react";
import Header from "./Header/Header";
import Landing from "./Landing/Landing";
import ProductUsed from "./ProductUsed/ProductUsed";
import OtherProjects from "./OtherProjects/OtherProjects";
import Gallery from "./Gallery/Gallery";
// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";

import IsError from "Components/RequestHandler/IsError";
import { useParams } from "react-router-dom";

const ProjectDetails = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`projects/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  const landingData = {
    image: data?.image,
    description: data?.description,
  };

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Header name={data?.title} />
        <Gallery data={data?.imageGallery} />
        <Landing data={landingData} />
        {data && data?.productUsed.length !== 0 && (
          <ProductUsed data={data?.productUsed} />
        )}
        {data && data?.otherProjectSameCategory.length !== 0 && (
          <OtherProjects data={data?.otherProjectSameCategory} />
        )}
      </main>
    );
  }
};

export default ProjectDetails;
